import {strip} from '@/common/questionsExporter/utility'

const fillInTheBlankQuestion = (question) => {
    const optionReducer = (acc, option) => {
        const optionLabel = option.option ? option.option : ''

        return acc + optionLabel + "\n"
    }
    const blankReducer = (acc, blank, index) => {
        const blankOptions = blank.options.reduce(optionReducer, '')

        return `${acc}Blank ${index + 1}\n${blankOptions}`
    }

    const prompt = question.question ? question.question : ''
    // replaces blank tags with underscores
    const expandedPrompt = prompt.replaceAll(/<blank [\w="\\ ]+><\/blank>/g, '___')

    const strippedPrompt = strip(expandedPrompt)
    const answerOptions = question.blanks ? question.blanks.reduce(blankReducer, '') : ''

    return `${strippedPrompt}\n${answerOptions}`
}

export {fillInTheBlankQuestion}
